import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import companyName from '../../defaultFieldDefinitions/CompanyName';
import county from '../../defaultFieldDefinitions/County';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import postCode from '../../defaultFieldDefinitions/PostCode';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as max from '../../max-length-validators';
import * as required from '../../required-validators';

const FieldDefinitionMY = [
  addressee,
  postCode,
  companyName,
  nameNumber,
  streetName,
  {
    ...addressLine2,
    maxLength: 35,
    validate: [max.lengthAddress(35)],
  },
  {
    ...townCity,
    maxLength: 30,
    validate: [required.townCity, max.lengthAddress(30)],
  },
  county,
];

export default FieldDefinitionMY;
